<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>
            <my-header h1="Data Verification Report" :h2="faculty"></my-header>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div v-for="item in data">
              <strong>{{item.Department}}</strong>
              <ol>
                <li v-for="i in item.Programs">
                  {{i.Program}}
                </li>
              </ol>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table style="padding:5%">
      <tr>
        <td>
          <span>
            <b>Note</b>: It is certifying that above information is correct and approved by the
            Board of studies.
          </span>
        </td>

      </tr>
      <tr>
        <td>
          <span>
            <br /><br />Signature and stamp <b>Dean:________________</b><br /><br />Date:______________ 
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>


<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        data: [],
        faculty:''
      }
    },
    mounted: function () {
      this.pagePrint();
    },
    methods: {
      pagePrint() {
        var vm = this;
        const params = new URLSearchParams(window.location.search);
        const FacultyID = params.get('FacultyID');
        axios.post('/api/AdmissionApi/loadDataVerificationReport?FacultyID=' + FacultyID)
          .then(function (res) {
            vm.data = res.data.final;
            vm.faculty = res.data.fname;
          })
      }
    }
  })
 </script>




// WEBPACK FOOTER //
// src/components/onlineadmission/dataVerificationPrint.vue